import {
  FETCH_PATIENTINVOICEDETAILS_SUCCESS_ACTION,
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_PATIENTINVOICEDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        patientInvoiceDtlsList: action.payload.rows,
        patientInvoiceDtlsCount: action.payload.count
      };
    default:
      return {
        ...state
      };
  }
}
